import { render, staticRenderFns } from "./WorkIconCopyProject.vue?vue&type=template&id=7e9dc71c"
import script from "./WorkIconCopyProject.vue?vue&type=script&lang=js"
export * from "./WorkIconCopyProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports